<template>
  <!-- <form class="form"> -->
  <div class="form">
    <div class="a-form-item">
      <label>手机号码:</label>
      <input type="number" v-model="user.phone" placeholder="请输入手机号码" />
      <countDownBtn
        :title="'发送验证码'"
        @click.native="getCode"
        ref="countDown"
      >
      </countDownBtn>
    </div>
    <div class="form-item">
      <label>验证码:</label>
      <input type="number" v-model="user.code" placeholder="请输入验证码" />
    </div>
    <div class="form-item">
      <label>输入新密码:</label>
      <input type="password" v-model="user.password" placeholder="请输入密码" />
    </div>
    <div class="form-item">
      <label>再次输入新密码:</label>
      <input type="password" v-model="cpwd" placeholder="请再次输入密码" />
    </div>
    <div class="btn">
      <button @click.prevent="submitHandle" html-type="submit">确定</button>
    </div>
  </div>
  <!-- </form> -->
</template>

<script>
import { getcode, resetPasswordByPhone } from "@/api/user"
import { checkPhone } from "@/utils/regCheck"

import countDownBtn from '@/components/countDomnBtn'
import debounce from '@/utils/debounce'

export default {
  components: {
    countDownBtn
  },
  data () {
    return {
      user: {
        code: '',
        phone: '',
        password: '',
      },
      cpwd: ''
    }
  },
  methods: {
    // 获取验证码
    getCode: debounce(async function (e) {
      e.preventDefault()
      const { phone } = this.user
      if (!checkPhone(phone)) {

        const result = await getcode({
          phone: phone,
          type: 'RESET_PASSWORD_BY_PHONE_CODE'
        })
        this.$toast(result.data.data.message)
        if (result.data.data.status) {
          this.$refs.countDown.start()
        } else {
          this.$refs.countDown.countDown()
        }
      }
    }, 200),
    // 提交表格
    async submitHandle () {
      const { cpwd, user, $toast } = this

      //判断两个密码是否正确
      if (cpwd !== user.password) {
        $toast('密码不一致 请重新输入');
        return;
      } else if (checkPhone(user.phone)) {
        $toast('请输入正确电话号码');
        return;
      } else if (user.code === '') {
        $toast('请输入验证码');
        return;
      }

      // 重设密码请求
      const result = await resetPasswordByPhone(user)

      this.$toast(result.data.data.message)
      if (result.data.data.status) {
        this.$router.replace({
          name: 'Login'
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.form {
  margin-top: 1rem;
  font-size: 0.32rem;
  label {
    // text-align: right;
    display: inline-block;
  }
  input {
    border: none;
    background: none;
    // width: 100%;
    margin: 0.1rem;
    padding: 0.1rem;
  }
  .form-item {
    // width: 90%;
    margin: 0.3rem 0.4rem;
    border-bottom: 1px solid rgb(227, 227, 227);
    padding: 0.3rem 0;
    display: flex;
    align-items: center;
  }
  .a-form-item {
    display: flex;
    align-items: center;
    margin: 0.3rem 0.4rem;
    border-bottom: 1px solid rgb(227, 227, 227);
    padding: 0.3rem 0;
    button {
      font-size: 0.25rem;
      margin: 0 0.1rem;
      color: #999999;
      width: 1.7rem;
      background: none;
      border: none;
    }
    input {
      width: 3rem;
    }
  }
  .btn {
    margin-top: 4rem;
    text-align: center;
    button {
      background: #ff6161;
      color: #fff;
      border: none;
      padding: 0.2rem 2rem;
      border-radius: 30px;
    }
  }
}
</style>